import LoadingIndicator from '@/widgets/LoadingIndicator'
import NoResultsIndicator from '@/widgets/NoResultsIndicator'
import { getSortIndicator } from '@/lib/tableHelpers'
import TypyPlacowekTableRow from './TypyPlacowekTableRow'

export default function TypyPlacowekTable({
	data,
	loading,
	sortColumn,
	sortDirection,
	onSort,
	onEdit,
	onDelete,
	onTypClick,
}) {
	const rows = Array.isArray(data) ? data : []

	if (loading) return <LoadingIndicator />

	return (
		<div className="mt-6 overflow-x-auto">
			<table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
				<thead>
					<tr>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<button
								type="button"
								className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
								onClick={() => onSort('typ')}>
								Typ
								{getSortIndicator('typ', sortColumn, sortDirection)}
							</button>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-right font-semibold text-gray-700">
							Akcje
						</th>
					</tr>
				</thead>
				<tbody>
					{rows.map(item => (
						<TypyPlacowekTableRow
							key={item._id || item.id || item.typ}
							typPlacowki={item}
							onEdit={onEdit}
							onDelete={onDelete}
							onTypClick={onTypClick}
						/>
					))}
				</tbody>
			</table>
			{rows.length === 0 ? (
				<div className="py-4">
					<NoResultsIndicator
						message="Nie znaleziono typow placowek"
						description="Sprobuj zmienic wyszukiwanie"
					/>
				</div>
			) : null}
		</div>
	)
}
